import { Avatar, Dropdown, Icon, Menu, Popover, Row, Col, Button, Select, Badge, Modal } from 'antd';
import React, { Fragment , useState, useEffect} from "react";
import { NavLink, withRouter } from 'react-router-dom';
import { Header, Search } from '../../common/UIComponents';
import { checkAccessExistance, checkServiceExistance, clearSession, findEnvironment, removeSpecialCharacters } from '../../helpers/common';
import WarehouseFilter from '../common/WarehouseFilter';
// import logo from "../../../assets/images/logo-thumbnail.png";
import AppConfig from '../../config/AppConfig';
import OrderFilter from '../orders/OrderFilter';
import EditIcon from '../common/EditIcon';
import SettingIcon from '../common/SettingIcon';
import { TableImageColumn } from '../../common/TableImageColumn';
import GlobalSearch from './GlobalSearch';
import NewGlobalSearch from './NewGlobalSearch';
import { AbleIcon } from '../../common/CustomIcon';
import { redirectToAble } from '../../common/MenuItems';
import { CompanyLogo } from '../common/LogisticsLoadingScreen';
import { marginLeft10 } from '../../helpers/invoice_styles';


const menu = (isSuperAdmin, isShipper, isDriver) =>
{
  return (
  <Menu>
    { checkServiceExistance("UME") && (
      <Menu.Item key="008">
        <NavLink to="/edit_profile">
          <SettingIcon/>
          <span className="nav-text">Edit Profile</span>
        </NavLink>
      </Menu.Item>
    ) }
    { checkServiceExistance("UCP") && (
      <Menu.Item key="009">
        <NavLink to="/changePassword">
          <EditIcon/>
          <span className="nav-text">Change Password</span>
        </NavLink>
      </Menu.Item>
    ) }
    {!isSuperAdmin && !isShipper && !isDriver && (
      <Menu.Item key="010">
      <NavLink to="/displaySettings">
        <Icon type="picture" style={{color:"#ad2102"}}/>
        <span className="nav-text">Display Settings</span>
      </NavLink>
    </Menu.Item>
    )}
    
    <Menu.Item>
      <a
        // href="/users/sign_out"
        onClick={clearSession}
      >
        <Icon type="logout" className="settings-icon" style={{color:"#eb2f96"}}  />
        <span className="nav-text">Sign Out</span>
      </a>
    </Menu.Item>
  </Menu>
  )
}


function getBadgeCount () {
  const hostname = window.location.hostname;
  if (hostname.includes('localhost')) return { count: 'dev', bgColor: '#add8e6', color: '#000' };
  if (hostname === 'stage.fleetenable.com') return { count: 'stage', bgColor: '#ffa500', color: '#000' };
  if (hostname === 'fe-beta.fleetenable.com') return { count: 'beta', bgColor: '#008000', color: '#fff' };
  return { count: null, bgColor: null, color: null };
}

function MenuOptions (props) {
  const { orderNumberSearch, filterPlaceHolder, handleFilterValueChange, handleFilterPlaceHolderChange, handleSearch,handleSaveNSearch, handleVisibleChange, filterWindow, landingPage, currentUser, 
    handleOnChange, isShipper, isDriver,WarehouseContext, isCollapsed, orgRules = {}} = props;
    const ENV = findEnvironment();
    const ENABLE_NEW_GLOBAL_SEARCH = orgRules?.org_billing_rules?.enable_global_search === "true" && ENV != "DEV";
  const orgLogo =currentUser?.currentOrg?.logo?.url;
  const badge = getBadgeCount();
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [modalKey, setModalKey] = useState(0);


  const closeAllAntdPopups = () => {
    // 1. Dispatch ESC events multiple times to close dropdowns/modals/drawers
    // This triggers Ant Design's built-in close handlers
    for (let i = 0; i < 5; i++) {
      setTimeout(() => {
        const escEvent = new KeyboardEvent('keydown', {
          key: 'Escape',
          code: 'Escape',
          keyCode: 27,
          which: 27,
          bubbles: true,
          cancelable: true
        });
        document.dispatchEvent(escEvent);
        window.dispatchEvent(escEvent);
        
        // Also trigger on any open modal backdrops
        const backdrops = document.querySelectorAll('.ant-modal-mask, .ant-drawer-mask');
        backdrops.forEach(backdrop => {
          backdrop.dispatchEvent(escEvent);
        });
      }, i * 10);
    }

    // 2. Click on modal masks to close them (React-friendly way)
    setTimeout(() => {
      const modalMasks = document.querySelectorAll('.ant-modal-mask');
      modalMasks.forEach(mask => {
        // Skip the global search modal mask
        const isGlobalSearchMask = mask.nextElementSibling?.classList.contains('route-start-modal-search');
        if (!isGlobalSearchMask) {
          try {
            mask.click();
          } catch (e) {
            console.log('Could not click mask:', e);
          }
        }
      });
      
      // Also click on drawer masks
      const drawerMasks = document.querySelectorAll('.ant-drawer-mask');
      drawerMasks.forEach(mask => {
        try {
          mask.click();
        } catch (e) {
          console.log('Could not click drawer mask:', e);
        }
      });
    }, 20);

    // 3. Find and click close buttons on modals and drawers
    setTimeout(() => {
      // Close modals
      const modalCloseButtons = document.querySelectorAll('.ant-modal-close, .ant-modal-close-x');
      modalCloseButtons.forEach(btn => {
        const modal = btn.closest('.ant-modal-wrap');
        const isGlobalSearch = modal?.querySelector('.route-start-modal-search');
        if (!isGlobalSearch) {
          try {
            btn.click();
          } catch (e) {
            console.log('Could not click close button:', e);
          }
        }
      });
      
      // Close drawers
      const drawerCloseButtons = document.querySelectorAll('.ant-drawer-close, .ant-drawer-close-x');
      drawerCloseButtons.forEach(btn => {
        try {
          btn.click();
        } catch (e) {
          console.log('Could not click drawer close button:', e);
        }
      });
    }, 30);
    
  };

  const openSearchModal = () => {
    
    closeAllAntdPopups();
    
    if (ENABLE_NEW_GLOBAL_SEARCH) {
      setModalKey(prev => {
        const newKey = prev + 1;
        return newKey;
      });
    }
    
    setTimeout(() => {
      setIsModalVisible(true);
    }, 200);
  };

  const closeSearchModal = () => {
    if (ENABLE_NEW_GLOBAL_SEARCH) {
        handleFilterPlaceHolderChange({
          ...filterPlaceHolder,
          search_order_token: '',
          search_key_value: '',
        });
    }
    setIsModalVisible(false);
  };

  useEffect(() => {
    const handleKeyDown = (e) => {
      if ((e.metaKey || e.ctrlKey) && (e.key === 'k' || e.key === 'K')) {
        if (props.isSuperAdmin) {
          return;
        }
        
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();
        
        
        
        if (ENABLE_NEW_GLOBAL_SEARCH) {
          if (isModalVisible) {
            setModalKey(prev => prev + 1);
          } else {
            openSearchModal();
          }
        } else {
          closeAllAntdPopups();
          setTimeout(() => {
            setIsModalVisible(true);
          }, 150);
        }
        
        return false;
      } else if (e.key === 'Escape' && isModalVisible && ENABLE_NEW_GLOBAL_SEARCH) {
        e.preventDefault();
        closeSearchModal();
      }
    };
    
    window.addEventListener('keydown', handleKeyDown, true);
    document.addEventListener('keydown', handleKeyDown, true);
    document.body.addEventListener('keydown', handleKeyDown, true);
    
    return () => {
      window.removeEventListener('keydown', handleKeyDown, true);
      document.removeEventListener('keydown', handleKeyDown, true);
      document.body.removeEventListener('keydown', handleKeyDown, true);
    };
  }, [isModalVisible, ENABLE_NEW_GLOBAL_SEARCH, props.isSuperAdmin]);

  if (ENABLE_NEW_GLOBAL_SEARCH) {
    // New implementation
    return (
      <div style={{minHeight: '96px'}}>
        
            <Row type="flex" style={{display:'flex', gap:'8px'}}>
              {
              false && !props.isSuperAdmin && !isDriver && checkAccessExistance('ORDER') &&
                checkServiceExistance([ "COFILTER", "COI" ], "ALL") && (<Col>
                    <NewGlobalSearch
                      history={props.history}
                      filterPlaceHolder={ filterPlaceHolder }
                      handleFilterValueChange={ handleFilterValueChange }
                      handleFilterPlaceHolderChange={ handleFilterPlaceHolderChange }
                      handleSearch={ handleSearch }
                      handleSaveNSearch={ handleSaveNSearch }
                      handleVisibleChange={ handleVisibleChange }
                      filterWindow={ filterWindow }
                      landingPage={ landingPage }
                      currentUser={ currentUser }
                      handleOnChange={ handleOnChange }
                      isShipper={ isShipper }
                      orderNumberSearch={ orderNumberSearch }
                      warehouseContext={WarehouseContext}
                    />
                </Col>)}
              
              { !props.isSuperAdmin && !isDriver && (
              <Col xs={24} className={`sidemenuFilter ${isCollapsed ? 'collapsed-side-menu' : ''}`}>
                <WarehouseFilter style={ { width: "100%"}} showIcon={true} showAllOption={false} faceValue={isCollapsed ? "location_code" : "name"} isCollapsed={isCollapsed}/>
              </Col>
              ) }
              { !props.isSuperAdmin && !isDriver && (
              <Col xs={24} className='alignCenter searchButton-div' onClick={openSearchModal} style={{padding: 8}}>
                {
                  isCollapsed ?
                  <Icon type="search" style={{ fontSize: 24 }} />
                  :
                   <div className='searchButton'>
                    <Icon type="search" style={{ fontSize: 24 }} />
                    <span className='searchText'>Search</span>
                    <span className='floatRight'>⌘ / ctrl + k</span>
                   </div>
                }
                
              </Col>
              ) }
              { !props.isSuperAdmin && !isDriver && (
              <Col xs={24} className='alignCenter searchButton-div ableButton' onClick={redirectToAble} style={{padding: 8}}>
                {
                  isCollapsed ?
                  <AbleIcon width={18} height={18} />
                  :
                   <div className='searchButton'>
                    <AbleIcon width={18} height={18} />
                    <span className='searchText'>Able</span>
                   </div>
                }
              </Col>
               ) }
            </Row>

        <Modal
              title={null}
              visible={isModalVisible}
              footer={null}
              closable={false}
              onCancel={closeSearchModal}
              maskClosable={true}
              className="route-start-modal-search"
              width={800}
              destroyOnClose={false}
              bodyStyle={{ 
                padding: 0,
                borderRadius: '16px',
                overflow: 'hidden'
              }}
              style={{ 
                top: 100,
                paddingBottom: 0
              }}
            >
               <NewGlobalSearch
                      key={modalKey}
                      history = {props.history}
                      filterPlaceHolder={ filterPlaceHolder }
                      handleFilterValueChange={ handleFilterValueChange }
                      handleFilterPlaceHolderChange={ handleFilterPlaceHolderChange }
                      handleSearch={ (refresh) => {
                        handleSearch(refresh)
                        closeSearchModal()
                      }}
                      handleSaveNSearch={ handleSaveNSearch }
                      handleVisibleChange={ handleVisibleChange }
                      filterWindow={ filterWindow }
                      landingPage={ landingPage }
                      currentUser={ currentUser }
                      handleOnChange={ handleOnChange }
                      isShipper={ isShipper }
                      orderNumberSearch={(value, searchType, fromGlobalFilter) => {
                        orderNumberSearch(value, searchType, fromGlobalFilter)
                        closeSearchModal()
                      }}
                      warehouseContext={WarehouseContext}
                      onClose={closeSearchModal}
                    />
            </Modal>
      </div>
    );
  }

  // Old implementation
  return (
    <div style={{minHeight: '96px'}}>
      
          <Row type="flex" style={{display:'flex', gap:'8px'}}>
            {
            false && !props.isSuperAdmin && !isDriver && checkAccessExistance('ORDER') &&
              checkServiceExistance([ "COFILTER", "COI" ], "ALL") && (<Col>
                  <GlobalSearch
                    filterPlaceHolder={ filterPlaceHolder }
                    handleFilterValueChange={ handleFilterValueChange }
                    handleFilterPlaceHolderChange={ handleFilterPlaceHolderChange }
                    handleSearch={ handleSearch }
                    handleSaveNSearch={ handleSaveNSearch }
                    handleVisibleChange={ handleVisibleChange }
                    filterWindow={ filterWindow }
                    landingPage={ landingPage }
                    currentUser={ currentUser }
                    handleOnChange={ handleOnChange }
                    isShipper={ isShipper }
                    orderNumberSearch={ orderNumberSearch }
                    warehouseContext={WarehouseContext}
                  />
              </Col>)}
            
            { !props.isSuperAdmin && !isDriver && (
            <Col xs={24} className={`sidemenuFilter ${isCollapsed ? 'collapsed-side-menu' : ''}`}>
              <WarehouseFilter style={ { width: "100%"}} showIcon={true} showAllOption={false} faceValue={isCollapsed ? "location_code" : "name"} isCollapsed={isCollapsed}/>
            </Col>
            ) }
            { !props.isSuperAdmin && !isDriver && (
            <Col xs={24} className='alignCenter searchButton-div' onClick={()=> setIsModalVisible(true)} style={{padding: 8}}>
              {
                isCollapsed ?
                <Icon type="search" style={{ fontSize: 24 }} />
                :
                 // <Search readOnly onClick={()=> setIsModalVisible(true)}/>
                 <div className='searchButton'>
                  <Icon type="search" style={{ fontSize: 24 }} />
                  <span className='searchText'>Search</span>
                  <span className='floatRight'>⌘ / ctrl + k</span>
                 </div>
              }
              
            </Col>
            ) }
            { !props.isSuperAdmin && !isDriver && (
            <Col xs={24} className='alignCenter searchButton-div ableButton' onClick={redirectToAble} style={{padding: 8}}>
              {
                isCollapsed ?
                <AbleIcon width={18} height={18} />
                :
                 <div className='searchButton'>
                  <AbleIcon width={18} height={18} />
                  <span className='searchText'>Able</span>
                 </div>
              }
            </Col>
            ) }
          </Row>

      <Modal
            title={"Search"}
            visible={isModalVisible}
            footer={null}
            closable={true}
            onCancel={() => setIsModalVisible(false)}
            maskClosable={true}
            width={600}
            destroyOnClose={true}
          >
             <GlobalSearch
                    filterPlaceHolder={ filterPlaceHolder }
                    handleFilterValueChange={ handleFilterValueChange }
                    handleFilterPlaceHolderChange={ handleFilterPlaceHolderChange }
                    handleSearch={ (refresh) => {
                      handleSearch(refresh)
                      setIsModalVisible(false)
                    }}
                    handleSaveNSearch={ handleSaveNSearch }
                    handleVisibleChange={ handleVisibleChange }
                    filterWindow={ filterWindow }
                    landingPage={ landingPage }
                    currentUser={ currentUser }
                    handleOnChange={ handleOnChange }
                    isShipper={ isShipper }
                    orderNumberSearch={(value, searchType, fromGlobalFilter) => {
                      orderNumberSearch(value, searchType, fromGlobalFilter)
                      setIsModalVisible(false)
                    }}
                    warehouseContext={WarehouseContext}
                  />
          </Modal>
    </div>
  );
}

export default withRouter(MenuOptions);